import { render } from "./booking-success.vue?vue&type=template&id=c5e46362"
import script from "./booking-success.vue?vue&type=script&lang=js"
export * from "./booking-success.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__